import React, { useState, useEffect } from "react";
import "../../CSS/Global.css";
import { useSidebar } from "../../SidebarContext";

const SettingsAccordion = () => {
    const { isSidebarOpen } = useSidebar();
    const [active, setActive] = useState(null);
    const [earning, setEarning] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const url=process.env.REACT_APP_LINK

    useEffect(() => {
        const fetchEarning = async () => {
            try {
                const res = await fetch(`${url}/api/earning/1`);
                const data = await res.json();
                if (res.ok) setEarning(data.amount || "");
            } catch (err) {
                console.error(err);
            }
        };
        fetchEarning();
    }, []);

    const toggleAccordion = (index) => {
        setActive(active === index ? null : index);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try {
            const res = await fetch(`${url}/api/earning`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ amount: Number(earning) }),
            });
            const data = await res.json();
            if (res.ok) setMessage("✅ Updated successfully!");
            else setMessage(`❌ ${data.error || "Update failed."}`);
        } catch {
            setMessage("❌ Network error.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <div className="accordion-container">
                <h1 className="accordion-title">Settings</h1>

                {/* Accordion 1: Staff Earning */}
                <div className={`accordion-item ${active === 1 ? "active" : ""}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(1)}>
                        <h2>Staff Earning</h2>
                        <span className="icon">{active === 1 ? "−" : "+"}</span>
                    </div>
                    <div className="accordion-content">
                        <form onSubmit={handleSubmit} className="earning-form">
                            <label>Earning per Video (₹)</label>
                            <input
                                type="number"
                                placeholder="e.g. 200"
                                value={earning}
                                onChange={(e) => setEarning(e.target.value)}
                                required
                                min="0"
                            />
                            <button disabled={loading}>
                                {loading ? "Saving..." : "Save"}
                            </button>
                            {message && <div className="feedback">{message}</div>}
                        </form>
                    </div>
                </div>

                {/* Accordion 2: Profile */}
                {/* <div className={`accordion-item ${active === 2 ? "active" : ""}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(2)}>
                        <h2>Profile</h2>
                        <span className="icon">{active === 2 ? "−" : "+"}</span>
                    </div>
                    <div className="accordion-content">
                        <p className="coming-soon">Profile settings coming soon...</p>
                    </div>
                </div> */}

                {/* Accordion 3: Notifications */}
                {/* <div className={`accordion-item ${active === 3 ? "active" : ""}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(3)}>
                        <h2>Notifications</h2>
                        <span className="icon">{active === 3 ? "−" : "+"}</span>
                    </div>
                    <div className="accordion-content">
                        <p className="coming-soon">Notification preferences coming soon...</p>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default SettingsAccordion;
